import React from 'react'

export interface InputGroupAddonProps {
    children: React.ReactNode;
    addonType?: 'prepend' | 'append' | string;
    onClick?: (e: React.MouseEvent) => void;
    [key: string]: any;
}

// Restores the Bootstrap 4 `.input-group-prepend` / `.input-group-append`
// wrapper that reactstrap 9 (BS5) no longer renders. The legacy Vuexy SCSS
// (e.g. `.input-group-merge .input-group-prepend .input-group-text { border-right: 0; }`)
// still targets these wrapper classes to style merged addons such as the
// public-libraries search input. See README.md for the migration rationale.
const InputGroupAddon: React.FC<InputGroupAddonProps> = ({ children, addonType, onClick, ...rest }) => {
    const wrapperClass = addonType === 'append' ? 'input-group-append' : 'input-group-prepend'
    const inner = onClick
        ? <span onClick={onClick}>{children}</span>
        : <>{children}</>
    return <div className={wrapperClass} {...rest}>{inner}</div>
}

export default InputGroupAddon
